import axios from 'axios'
const REACT_APP_API_URL = process.env.REACT_APP_API_URL

export const getUsers = async () => {

  try {
    const url = `${REACT_APP_API_URL}/token-provider`
    const headers = {
      'Authorization': `Bearer ${await localStorage.getItem('dashboard_access_token')}`,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
    const body = {
      "type": "list_users",
    }
    const response = await axios.post(url, {...body}, {headers: headers})
    return response.data;
  } catch (error) {
    
    return error;
  }
}


